var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 37,
    viewBox: "0 0 27 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.494 0C6.05469 0 3.19006e-06 6.0571 0 13.4964C-4.66239e-06 26.5864 12.7344 36.5376 12.7344 36.5376C13.1817 36.8939 13.8159 36.8939 14.2632 36.5376C14.2632 36.5376 27 26.5864 27 13.4964C27 6.0571 20.9333 0 13.494 0ZM13.494 7.36407C16.8676 7.36407 19.6359 10.1228 19.6359 13.4964C19.636 16.87 16.8676 19.6359 13.494 19.6359C10.1204 19.6359 7.36166 16.87 7.36168 13.4964C7.36169 10.1228 10.1204 7.36407 13.494 7.36407Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.a412ca40d688a4e6ab42b03776abefc1.svg";
export { ForwardRef as ReactComponent };